function Footer() {
    return (
      <footer className="bg-dark text-light py-4">
        <div className="container">
          <div className="row text-center text-md-start align-items-center">
            <div className="col-md-6 mb-3 mb-md-0">
              <h5>Trustlife Medical</h5>
              <p className="mb-0">© {new Date().getFullYear()} Tüm Hakları Saklıdır.</p>
            </div>
            <div className="col-md-6 text-md-end">
              <a href="#hero" className="text-light me-3 text-decoration-none">Anasayfa</a>
              <a href="#about" className="text-light me-3 text-decoration-none">Hakkımızda</a>
              <a href="#services" className="text-light me-3 text-decoration-none">Hizmetler</a>
              <a href="#contact" className="text-light text-decoration-none">İletişim</a>
            </div>
          </div>
        </div>
      </footer>
    );
  }
  
  export default Footer;